import { Fragment } from 'react';
import { CashierShiftTransaction } from '@mews-commander/data-access';
import { Grid, GridItem } from '@optimus-web/core';
import { LocalizedDateTimeFromUtc, LocalizedTypography } from '@mews-commander/ui';
import { TextKey } from '@mews-commander/enums';
import { LocalizedCurrencyValue } from '@mews/framework';
import { UnicodeEntity } from '@mews/enums';

interface Props {
    transaction: CashierShiftTransaction;
}

export const TransactionDetailContent = ({ transaction }: Props) => {
    const table = {
        [TextKey.Number]: transaction.number,
        [TextKey.Created]: <LocalizedDateTimeFromUtc utcString={transaction.createdUtc} />,
        [TextKey.Issuer]: transaction.creatorName || UnicodeEntity.Dash,
        [TextKey.Value]: <LocalizedCurrencyValue value={transaction.amount} />,
        [TextKey.Customer]: transaction.customerName || UnicodeEntity.Dash,
        [TextKey.Notes]: transaction.notes,
    };

    return (
        <Grid templateColumns="1fr 1fr" gap="100">
            {Object.entries(table).map(([key, value]) => (
                <Fragment key={key}>
                    <GridItem>
                        <LocalizedTypography
                            as="span"
                            textKey={key as TextKey}
                            variant="tertiary"
                            textStyle="bodyMedium"
                        />
                    </GridItem>
                    <GridItem>{value}</GridItem>
                </Fragment>
            ))}
        </Grid>
    );
};
